import React from 'react'
import PropTypes from 'prop-types'

import { components as SelectComponents } from 'react-select'
import { MenuListLabels } from 'component/reactSelect/MenuListLabels'

const CustomMenuList = (props) => {
  const {
    selectProps: { value },
  } = props

  return (
    <>
      {value !== null && value.length > 1 && (
        <>
          <MenuListLabels {...props.selectProps} />
          <span className='separator' />
        </>
      )}

      <SelectComponents.MenuList {...props} />
    </>
  )
}

CustomMenuList.propTypes = {
  hasValue: PropTypes.bool.isRequired,
  selectProps: PropTypes.object.isRequired,
}

export { CustomMenuList }
